import img from "../../../img/1.svg";
import img2 from "../../../img/2.svg";
import img3 from "../../../img/3.svg";
import img4 from "../../../img/4.svg";
import img5 from "../../../img/5.svg";
import img6 from "../../../img/6.svg";
import img7 from "../../../img/7.svg";
import img8 from "../../../img/8.svg";
import img9 from "../../../img/9.svg";

export const sideBarMenu = [
  {
    img: "dash",
    title: "Dashboard",
    to: "/",
  },
  {
    img: "transaction",
    title: "Transactions",
    to: "/transactions",
  },
  {
    img: "account",
    title: "Accounts",
    to: "/account",
  },
  {
    img: "invest",
    title: "Investments",
    to: "/invest",
  },
  {
    img: "credit",
    title: "Credit Cards",
    to: "/credit",
  },
  {
    img: "loan",
    title: "Loans",
    to: "/loans",
  },
  {
    img: "services",
    title: "Services",
    to: "/services",
  },

  {
    img: "setting",
    title: "Setting",
    to: "/settings",
  },
];
